// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   //apiPrefix: "http://10.46.90.186:53126",
//   apiPrefix : "http://localhost:52124",
//   rpPrefix: "",
//   //servicesPrefix: "/Services"
//   servicesPrefix: "",
//   authApiPrefix: "http://localhost:52123",
//   pswManagementPrefix: "http://www.passwordmanagementrai.rai.it",
//   helpAddress: "help-sanremogiovani@rai.it"
// };

export const environment = {
  production: true,
  apiPrefix: "",
  rpPrefix: "",
  servicesPrefix: "/Services", 
  authApiPrefix: "/auth",
  pswManagementPrefix: "http://www.passwordmanagementrai.rai.it",
  helpAddress: "help-sanremogiovani@rai.it"
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
